import { ClientStatusList } from 'actions/actionTypes';

// 이벤트
export const changeSearchFilter = (type, name, value) => ({ type: ClientStatusList.CHANGE_CLIENT_STATUS_SEARCH_FILTER, payload: { type, name, value } });

// 클라이언트 목록
export const loadClientStatusListRequest = () => ({ type: ClientStatusList.LOAD_CLIENT_STATUS_LIST_REQUEST });
export const loadClientStatusListRequestSuccess = (responseData) => ({ type: ClientStatusList.LOAD_CLIENT_STATUS_LIST_REQUEST_SUCCESS, payload: responseData });
export const loadClientStatusListRequestFailure = (errorMessage) => ({ type: ClientStatusList.LOAD_CLIENT_STATUS_LIST_REQUEST_FAILURE, payload: errorMessage });

// 단일 클라이언트 업데이트
export const changeClientStatus = (clientGuid, name, value) => ({ type: ClientStatusList.CHANGE_CLIENT_STATUS, payload: { clientGuid, name, value } });